<template>
  <div></div>
</template>

<script>
import http from "../common/http.js";

export default {
  data() {
    return {};
  },
  async mounted() {

    let appid = "wx8f893adb1c19030a" //研可颜

    var wxsvcbase = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri="

    let tCode = this.$route.query.tCode
    // let logisticcode  = this.$route.query.logisticcode
    // let goodsUrl = `${tCode}?logisticcode=${logisticcode}`   //new
    // let goodsUrl = `${tCode}`

   
    let {data}=this.$route.query || {}
    // let redirectUrl = encodeURIComponent("https://test.hkaspire.net/integral/public/scancode/" + appid + "/" + tCode) //测试
    // let redirectUrl = encodeURIComponent("https://test.hkaspire.net/integral/public/scancode/" + appid + "/" + goodsUrl) //测试   //new
    // let redirectUrl = encodeURIComponent("https://test.hkaspire.net/integral/public/scancode/" + appid + "/" + tCode + 'logisticcode='+  logisticcode) //测试
    // let redirectUrl = encodeURIComponent("https://app.hkaspire.cn/integral/public/scancode/" + appid + "/" + goodsUrl) //线上  //new
    let redirectUrl = encodeURIComponent("https://app.hkaspire.cn/integral/public/scancode/" + appid + "/" + tCode) //线上
    let url = ''
    // url = encodeURIComponent(`https://test.hkaspire.net/#/ykyCodeIndex?j=j`) //测试
    // url = encodeURIComponent(`http://192.168.200.182:8080/#/ykyCodeIndex?j=j`) //本地
    url = encodeURIComponent(`https://emoj.caredaily.com/#/ykyCodeIndex?j=j${data}&tCode=${tCode}`) //线上

    // console.log(url)
    // console.log(wxsvcbase)
    // console.log(redirectUrl)
    window.location = wxsvcbase + redirectUrl + "&response_type=code&scope=snsapi_userinfo&state=" + url + "#wechat_redirect"
    if (this.$route.query) {
      this.setCode()
    }
  },
  methods: {
    async setCode() {
      // let urlSearchParams = new URLSearchParams(this.$route.query);
      // let name = urlSearchParams.get("name");
      // let validate = urlSearchParams.get("validate");
      // console.log(aaValue); // 输出: 111
      // console.log(bValue); // 输出: 2222
      let arr = this.$route.query.data.split('&')
      let data = {}
      // alert(arr)
      if (arr.length > 1) {
        data = {
          code: this.$route.query.tCode,
          goods_name: arr[1].replace("name=", ""),
          validate: arr[2].replace("validate=", ""),
          logisticcode:arr[3].replace("logisticcode=", ""),
        }
      } else {
        data = {
          code: this.$route.query.tCode
        }
      }

      // alert(JSON.stringify(data))
      await http.post("/integral/public/trace-code/goods-name", data)
    },
  }
};
</script>

<style scoped>
</style>
